import { Helmet } from "react-helmet-async";
import '../styles/equipamentos2.min.css';

import Img1 from '../assets/pilates-banner-equip-cadillac.png';
import Img2 from '../assets/banner-404-agrupado.png';
import Img3 from '../assets/chair.png';

export default function Home() {

   return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/equipamentos/chair" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma." />
        </Helmet>

        <main>

            <section className="equipamentos-pilates">

                <div className="equip-cadillac-banner-box">

                    <div className="equip-pilates-banner-img">
                        <img className="hide--mobile" src={Img1}/>
                        <img className="hide--desk" src={Img2}/>
                    </div>

                    <div className="equip-pilates-title">
                        <h1> Equipamento <br/><span className="text-bold"> Chair</span> </h1>
                        <img className="cadillac-img" src={Img3}/>
                    </div>

                </div>

                <div className="pilates-cadillac-title">
                    <h2>
                        Não deixe a palavra chair (cadeira)<br/> enganar você - ela não é exatamente um <br/>local para se sentar
                    </h2>
                </div>

                <div className="chair-text pilates-cadillac-text">

                    <span>
                        Enganosamente lembrando um estiloso e pequeno banquinho, o Pilates Chair (cadeira), mais conhecido
                        como Wunda Chair ou Stability Chair, é uma versátil máquina de exercícios. Não deixe a palavra "chair
                        (cadeira)" enganar você - ela não provê necessariamente exercícios para se sentar.<br/><br/>

                        Enquanto muitos dos exercícios do Pilates são realizados sentados no topo e pressionando para baixo os
                        pedais com seus pés, outros exigem que se deite no chão, estabilize o corpo diretamente acima ou fazendo
                        flexão de braços como movimentos apenas com os braços. Mais de 75 exercícios pode ser realizados no Chair.
                        Isto o faz ser de grande valia na sua rotina de trabalho físico.<br/><br/>

                        Mais uma vez, molas ajustáveis de resitência são a chave para desafiar você nos exercícios. Na maioria dos
                        modelos, 4 molas e 5 encaixes de molas fornecem uma grande faixa de resistência. Enquanto pressionando
                        para baixo o pedal com os braços ou pernas, os músculos da estabilização trabalham para cima no tronco
                        (Isto é mais difícil do que parece). Este aparelho ativa a parte inferior das costas, glúteos, ombros,
                        tranverso do abdômen e região pélvica, além de aumentar a coordenação neuromuscular. De uma perspectiva de
                        reabilitação, o Pilates Chair é particularmente efetivo para alongamento e rebalanceamento dos músculos
                        que foram lesionados.<br/><br/>
                    </span>
                </div>

            </section>

        </main>
    </>
  );
}